export function formatZodError(zodError) {
  const fieldErrors = zodError.flatten().fieldErrors;
  const messages = [];

  for (const [field, errors] of Object.entries(fieldErrors)) {
    if (errors && errors.length > 0) {
      messages.push(`${field}: ${errors.join(", ")}`);
    }
  }

  return messages.length > 0
    ? messages.join("; ")
    : "Validation failed. Please check your input.";
}

export function setFormErrorsFromZod(zodError, setError) {
  const fieldErrors = zodError.flatten().fieldErrors;

  for (const [field, errors] of Object.entries(fieldErrors)) {
    if (errors && errors.length > 0) {
      setError(field, {
        type: "validation",
        message: errors[0],
      });
    }
  }
}
